module.exports = __webpack_public_path__ + "static/media/7_of_clubs.768d16ac.svg";